// import { useTranslation } from "react-i18next";
import { useEffect, useState, useRef } from 'react';
import moment from "moment";
import { Button, ButtonType, ButtonSize } from "@components/new/Button";
import { LinkButton } from "@components/new/LinkButton";

export enum ButtonWithTimerType {
  LINK = "link",
}

interface ButtonWithTimerProps {
  title: string;
  onClick: () => void;
  pending?: boolean;
  asLink?: boolean;
  type?: ButtonType;
  timeout?: number;
  startTimerFromOutside?: boolean;
  disabledOnTimer?: boolean;
  size?: ButtonSize;
  isWide?: boolean;
}

const TIMEOUT = 60;

const formatTime = (time: number) => {
  return moment(time * 1000).format("mm:ss");
}

const ButtonWithTimer: React.ComponentType<ButtonWithTimerProps> = ({
  onClick,
  asLink,
  type,
  title,
  pending,
  timeout,
  startTimerFromOutside,
  disabledOnTimer,
  size,
  isWide,
}: ButtonWithTimerProps) => {
  // const { t } = useTranslation();
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [timer, setTimer] = useState(timeout || TIMEOUT);
  const intervalRef = useRef<ReturnType<typeof setTimeout> | undefined>();

  useEffect(()=> {
    startTimerFromOutside && handlerStartTimer();
  }, [startTimerFromOutside]);

  const handlerStartTimer = () => {
    if (intervalRef.current) clearInterval(intervalRef.current)
    setIsButtonDisabled(Boolean(disabledOnTimer));
    let counter = timeout || TIMEOUT;
    intervalRef.current = setInterval(() => {
      counter--;
      setTimer(counter);
      if (counter === 0) {
        clearInterval(intervalRef.current);
        setIsButtonDisabled(!disabledOnTimer);
      }
    }, 1000);
  };

  const handleClick = () => {
    handlerStartTimer();
    onClick();
  };

  if (asLink) {
    return (
      <LinkButton
        disabled={isButtonDisabled || pending}
        onClick={handleClick}
        title={(timer > 0) ? `${title} ${formatTime(timer)}` : title}
      />
    );
  }

  return (
    <Button
      disabled={isButtonDisabled}
      loading={pending}
      onClick={handleClick}
      title={(timer > 0) ? `${title} ${formatTime(timer)}` : title}
      type={type}
      size={size}
      isWide={isWide}
    />
  );
};

export default ButtonWithTimer;
